export function getGroupSubsidiaryPrefix(group, consolidations) {
  let subPrefix = '';

  const { cgroupId } = group;
  if (cgroupId !== null) {
    const subsidiaryId = consolidations.cgroupsById[cgroupId].subId;
    subPrefix = consolidations.subsidiariesById[subsidiaryId].name;
  }

  return subPrefix;
}
